export const PALETTE = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  DARK: "#30302f",
  LIGHTGRAY: "#f5f5f5",
  VERYKINDALIGHTGRAY: "#eeeeee",
  KINDALIGHTGRAY: "#e5e5e5",
  LIGHTGRAYTRANSPARENT: "rgb(245, 245, 245, 0.5)",
  LIGHTGRAYKINDATRANSPARENT: "rgb(245, 245, 245, 0.95)",
  DARKTRANSPARENT: "rgb(18, 18, 17, 0.9)",
  GRAY: "rgb(0,0,0,0.4)",
  TRUEGRAY: "#b2b2b2",
  TRUEKINDAGRAY: "#d1d5db",
  KINDAGRAY: "rgb(0,0,0,0.2)",
  DARKGRAY: "#6b6a6a",
  MAINCOLOR: "#ff7c00",
  // MAINCOLOR: "#f8ba20",
  MAINCOLORLIGHT: "#fce1c8",
  SECONDARYCOLOR: "#290a59",
  SECONDARYCOLORKINDALIGHT: "#7858a8",
  SECONDARYCOLORLIGHT: "#eae0fa",
  MAINCOLORHOVER: "#fa9c43",
  SECONDARYCOLORHOVER: "#724ab0",
  SECONDARYCOLORTRANSPARENT: "rgb(39, 10, 89, 0.3)",
  GREEN: "green",
  GREEN2: "#006e14",
  GREEN3: "#80ef80",
  LIGHTGREEN: "#006e144f",
  RED: "#dc3545",
  RED2: "#ab4d46",
  GOLD: "#fdb934",
  GRADIENT: `
    linear-gradient(217deg, rgb(39, 37, 155, .7), rgb(39, 37, 155, .0) 70.71%),
    linear-gradient(127deg, rgb(225, 105, 25, .7), rgb(255, 105, 25, .0) 70.71%),
    linear-gradient(336deg, rgb(184, 42, 139, .7), rgb(184, 42, 139, .0) 70.71%)
  `,
  GRADIENTLIGHT: `
    linear-gradient(217deg, rgb(39, 37, 155, .1), rgb(39, 37, 155, .0) 70.71%),
    linear-gradient(127deg, rgb(225, 105, 25, .1), rgb(255, 105, 25, .0) 70.71%),
    linear-gradient(336deg, rgb(184, 42, 139, .1), rgb(184, 42, 139, .0) 70.71%)
  `,
  LINEARGRADIENT: `
    linear-gradient(0deg, #724ab0 0%, rgb(250, 156, 67) 100%)
  `,
  LINEARGRADIENTINVERT: `
    linear-gradient(0deg,rgb(250, 156, 67) 0%, #724ab0 100%)
  `,
  CIRCLETRANSPARENTGRADIENT: `
  radial-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 65%)`,
  CIRCLETRANSPARENTGRADIENTLIGHT: `
  radial-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0) 65%)`,
  HORIZONTALLINEARGRADIENTTRANSPARENT: `linear-gradient(90deg, rgba(255, 255, 255, 0.1), rgba(245, 245, 245, 1))`,
  VERTICALLINEARGRADIENTTRANSPARENT: `linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(245, 245, 245, 1))`,
  VERTICALLINEARGRADIENTTRANSPARENTDARK: `linear-gradient(180deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
  VERTICALLINEARGRADIENTTRANSPARENTDARKINVERSE: `linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
};
